export const mergeById = (prev = [], incoming = []) => {
  const map = new Map();

  // First, insert incoming in order (page 0 = authoritative)
  for (const item of incoming) {
    map.set(item.id, item);
  }

  // Then fill in anything already loaded
  for (const item of prev) {
    if (!map.has(item.id)) {
      map.set(item.id, item);
    }
  }

  return Array.from(map.values());
};